import { useState } from 'react';
import { Box, Stack, Text, TextField, RadioGroup, Radio } from '@customerio/pluma-components/react';
import { AUDIT_OBJECT_TYPE_TO_FIELDS } from '../../constants/auditFieldOptions';

interface AttributeNameFilterProps {
  value: string;
  onChange: (value: string) => void;
  objectType: string | undefined;
}

export const AttributeNameFilter: React.FC<AttributeNameFilterProps> = ({ value, onChange, objectType }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const availableAttributes =
    objectType !== '' && objectType !== undefined
      ? AUDIT_OBJECT_TYPE_TO_FIELDS[objectType as keyof typeof AUDIT_OBJECT_TYPE_TO_FIELDS] ?? []
      : [];
  const hasAttributes = availableAttributes.length > 0;

  // Filter attributes based on search query (trim whitespace for better matching)
  const trimmedQuery = searchQuery.trim();
  const filteredAttributes =
    trimmedQuery === ''
      ? availableAttributes
      : availableAttributes.filter((attr: string) => attr.toLowerCase().includes(trimmedQuery.toLowerCase()));

  return (
    <Box p="300">
      {!hasAttributes ? (
        <Text size="s" color="subtle">
          No attributes available. Select an Object Type to see attribute options.
        </Text>
      ) : (
        <Stack gap="200">
          {/* Note: Using onInput instead of onChange is required for TextField to work correctly
              in DataTable filter popovers. onChange causes the input to become unresponsive. */}
          <TextField
            value={searchQuery}
            onInput={(e) => setSearchQuery(e.target.value)}
            placeholder="Search attributes..."
            label="Search attributes"
          />
          <Box style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {filteredAttributes.length > 0 ? (
              <RadioGroup value={value ?? ''} onChange={onChange} label="Attribute Options">
                {filteredAttributes.map((attr: string) => (
                  <Radio key={attr} label={attr} value={attr} />
                ))}
              </RadioGroup>
            ) : (
              <Text size="s" color="subtle">
                No attributes found
              </Text>
            )}
          </Box>
        </Stack>
      )}
    </Box>
  );
};
